export const setNotificacoes = ({ commit }, payload) => {
  commit('SET_NOTIFICACOES', payload)
}

export const setQtdNotRead = ({ commit }, payload) => {
  commit('SET_QTD_NOT_READ', payload)
}

export const setLoading = ({ commit }, payload) => {
  commit('SET_LOADING', payload)
}
